// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__bXlZK","label":"Radio_label__3RYgK","checkMark":"Radio_checkMark__1Gq5V","disabled":"Radio_disabled___Lz8O"};